import React from "react";
import "../../Assessts/Styles/Home.scss";
import { Row, Col } from "react-bootstrap";

import SlidingFrame from "./SlideingFrame";

import Scholarships from "../../Assessts/Images/Home/Scholarships.svg";
import AScholarships from "../../Assessts/Images/Home/AScholarships.svg";
import ENCP from "../../Assessts/Images/Home/ENCP.svg";

import AboutUs from "../../Assessts/Images/Home/AboutUs.png";
import ISP from "../../Assessts/Images/Home/ISP.svg";
import ICP from "../../Assessts/Images/Home/ICP.svg";

import Ncpwork from "../../ReUableComponents/ncpwork.jsx";
import SlidingWithButtons from "./SlidingwithButtons.jsx";
import Patners from "./Patners.jsx";

const Home = () => {
    const DetailsNCF = [
        { Name: "Scholarships", value: "11,000+", icon: Scholarships },
        { Name: "Awarded in scholarships", value: "₹55+ Cr", icon: AScholarships },
        { Name: "Enrolled in NCP", value: "2,50,000+", icon: ENCP },
    ]
    return (
        <>
            <SlidingFrame />

            <div className="dflex H-Aboutus">
                <div className="dflex alignitems">
                    <img src={AboutUs} alt="About Us" /></div>
                <div className="">
                    <span className="Web-MainHeading" style={{ justifyContent: "flex-start" }}>About Us</span>
                    <p>North South Foundation (NSF) is a non-profit organization based in Hyderabad, founded in 2004, dedicated to promoting educational excellence among economically disadvantaged students in India.</p>
                    <p className="mt-2"><b>NSF Scholarship Program (NSP) :</b> NSF provides merit-cum-need-based scholarships to undergraduate students pursuing engineering, medicine, and three-year diploma programs. The program not only eases financial constraints but also empowers students to complete their education and achieve long-term career success.</p>
                    <p className="mt-2"><b>NSF Competency Program (NCP) :</b>  NCP is an assessment-driven learning initiative that offers free, curriculum-aligned, competency-based assessments to government schools across India. Using an online platform and detailed dashboards, NCP helps improve learning outcomes through continuous feedback and targeted support.</p>


                    <div className="dflex gap-5 JCCenter mt-4 NCF-DetailsMainDiv p-0">
                        {DetailsNCF.map((item) => (
                            <div className="dflex flexd-column alignitems gap-2 NCFDetails">
                                <span>{item?.value}</span>
                                <span>{item?.Name}</span>
                                <span className="NCFDetails-icon"><img src={item?.icon} alt={item?.Name} /></span>
                            </div>
                        ))}
                    </div>

                </div>
            </div>





            <div className="p-3" >
                <div className="dflex JCCenter flexd-column alignitems HCBL">
                    <span className="Web-MainHeading mb-3">Our Programs</span>
                    <p >North South Foundation (NSF) works to expand educational opportunities for deserving students across India.  Through scholarships and competency-based programs, NSF drives access, equity, and learning excellence.</p>
                </div>


                <div className="container-fluid mt-3 ">
                    <Row className="OPrograms dflex gap-3">
                        <Col >
                            <div className="dflex  flexd-column alignitems p-3" >
                                <img src={ISP} alt="India Scholarships Program"  />
                                <div className="OURVMH" style={{backgroundColor:"inherit"}}> <span className="Web-SubHeading">India Scholarships Program</span>
                                    <p> North South Foundation provides merit and need based scholarships to undergraduate students entering engineering, medicine, or three year diploma programs, supporting academic journeys and nurturing student potential nationwide success overall.</p></div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dflex  flexd-column alignitems p-3" >

                                <img src={ICP} alt="India Competency Program"  />
                                <div className="OURVMH" style={{backgroundColor:"inherit"}}>
                                    <span className="Web-SubHeading">India Competency Program</span>
                                    <p>NSF Competency Program offers free competency based assessments aligned with curriculum for government schools across India, using online platforms, dashboards, and question banks to deliver comprehensive feedback and learning support.</p>
                                </div>
                            </div>
                        </Col>
                    </Row></div>
            </div>
            <Patners />
            <SlidingWithButtons />

        </>
    )
}
export default Home;